import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Unit } from './unit.model';
import { UnitInterface } from './unit.interface';
import { UnitFactory } from './unit.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class UnitService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Unit>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<UnitInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/units`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => UnitFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<Unit> {
        return this.http
            .get<UnitInterface>(`${environment.apiUrl}/v${environment.apiVersion}/units/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => UnitFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(units: Unit): Observable<any> {
        if (units.id) {
            return this.http
                .put(`${environment.apiUrl}/v${environment.apiVersion}/units/${units.id}`, units, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/units`, units, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }



    updateOrder(unitId: string, items: any[]): Observable<any> {

        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/units`, { items }, { headers: this.authService.headers() })
            .pipe(map(item => UnitFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/units/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Unit>> {
        return this.http
            .get<UnitInterface[]>(`${this.api}/units/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawUnit => UnitFactory.fromObject(rawUnit)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/units/shared/unit.service.ts